import $ from "jquery";

const setLinkTargets = () => {
  // all links
  $("a").each(function () {
    if ($(this).attr("href")) {
      var href = $(this).attr("href");
      var siteHostname = window.location.host;
      // check if href ends with .pdf
      var exPDF = new RegExp("\\.pdf$").test(href);
      // check if href has hostname inside
      if (href.indexOf(siteHostname) > -1) {
        if (exPDF) {
          $(this).attr("target", "_blank");
        } else {
          $(this).attr("target", "_self");
        }
        // check if internal link (remote content)
        // if ($(this).attr('href').includes('index.php') || $(this).attr('href').includes('?u=')) {
        // 	$(this).attr('target', '_self');
        // } else {
        // 	// check if href ends with / or .php
        // 	var ex1 = (new RegExp('\\.php$|\\/$')).test(href);
        // 	if (ex1) {
        // 		$(this).attr('target', '_self');
        // 	} else {
        // 		$(this).attr('target', '_blank');
        // 	}
        // }
      } else {
        if (exPDF) {
          $(this).attr("target", "_blank");
        } else {
          // check if href starts with / or is only #
          var ex2 = new RegExp("^\\/.*|^#.*").test(href);
          if (ex2 || $(this).attr("href").includes("javascript")) {
            $(this).attr("target", "_self");
          } else {
            $(this).attr("target", "_blank");
          }
        }
      }
    }
  });
};

export const init = () => {
  let attempts = 0;

  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;

    if (document.readyState === "complete") {
      setLinkTargets();
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };

  whenComplete();
};
